const { WINPOT_CASINO_URL } = require('../../utils/consts');

export const headerNav = [
    {
        id: 0,
        name: 'header.nav.casino',
        link: `${WINPOT_CASINO_URL}casino`,
        linkType: 'casino',
        mobileIcon: 'assets/images/casino.svg',
    },
    {
        id: 1,
        name: 'header.nav.casino.live',
        link: `${WINPOT_CASINO_URL}live/lobby`,
        linkType: 'casino-live',
        mobileIcon: 'assets/images/casino-en-vivo.svg',
    },
    {
        id: 2,
        name: 'header.nav.sport',
        link: `${WINPOT_CASINO_URL}sport`,
        linkType: 'sport',
        mobileIcon: 'assets/images/sport.svg',
    },
    {
        id: 3,
        name: 'header.nav.sport.live',
        link: `${WINPOT_CASINO_URL}live-sport`,
        linkType: 'sport-live',
        mobileIcon: 'assets/images/sport-en-vivo.svg',
    },
    {
        id: 4,
        name: 'header.nav.sport.virtual',
        link: `${WINPOT_CASINO_URL}virtual-sports`,
        linkType: 'sport-virtual',
        mobileIcon: 'assets/images/virtuales.svg',
    },
    {
        id: 5,
        name: 'header.nav.promotions',
        link: `${WINPOT_CASINO_URL}promotions`,
        linkType: 'promo',
        mobileIcon: 'assets/images/promotions.svg',
    },
    {
        id: 6,
        name: 'header.nav.vip',
        link: `${WINPOT_CASINO_URL}winclub`,
        linkType: 'vip',
        mobileIcon: 'assets/images/vip.svg',
    },
];

export const infoSubmenu = [
    {
        name: 'header.nav.information.item_1',
        link: `${WINPOT_CASINO_URL}info/open-an-account`,
    },
    {
        name: 'header.nav.information.item_2',
        link: `${WINPOT_CASINO_URL}info/deposits-to-your-account`,
    },
    {
        name: 'header.nav.information.item_3',
        link: `${WINPOT_CASINO_URL}info/bonus-information`,
    },
    {
        name: 'header.nav.information.item_4',
        link: `${WINPOT_CASINO_URL}info/betting-rules`,
    },
];
